//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Footer from '../components/footer.vue'
    export default {
        name: 'app',
        components:{
            'pc-footer':Footer,
        },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/setting.vue